'use client'

import { useCallback, useState } from 'react'

import { useServerRequests } from '~/hooks/useRequests'

export const useTriggerAutomation = (automationId?: string) => {
  const { serverPostRequest } = useServerRequests()
  const [isTriggering, setIsTriggering] = useState(false)

  const trigger = useCallback(async () => {
    if (!automationId) return
    setIsTriggering(true)
    try {
      await serverPostRequest<{ success: boolean }>({
        path: `/api/org/automations/${automationId}/trigger`,
        params: {},
        successMessage: 'Automation triggered',
        errorMessage: 'Failed to trigger automation',
      })
    } finally {
      setIsTriggering(false)
    }
  }, [serverPostRequest, automationId])

  return { trigger, isTriggering }
}
